(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enterprise-cart"] && !Shopify.designMode) return;
  try {
    
(() => {
  let quantityTimer;

  const submitCart = (form) => {
    if (!form) return;
    form.classList.add('is-updating');
    form.submit();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-quantity]');
    if (!button) return;
    const wrapper = button.parentElement;
    const input = wrapper.querySelector('[data-cart-quantity-input]');
    if (!input) return;
    const change = button.dataset.cartQuantity === 'plus' ? 1 : -1;
    input.value = Math.max(0, Number(input.value || 0) + change);
    clearTimeout(quantityTimer);
    quantityTimer = setTimeout(() => submitCart(button.closest('form')), 350);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-quantity-input]');
    if (!input) return;
    input.value = Math.max(0, Number(input.value || 0));
    clearTimeout(quantityTimer);
    quantityTimer = setTimeout(() => submitCart(input.closest('form')), 350);
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-enterprise-cart-quick-add]');
    if (!button || button.dataset.busy === 'true') return;
    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    const initialText = button.textContent;
    button.dataset.busy = 'true';
    button.disabled = true;
    button.textContent = 'Wird hinzugefügt …';

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: variantId, quantity: 1}]})
      });
      if (!response.ok) throw new Error('Cart add failed');

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event: 'enterprise_cart_cross_sell_add', product_id: button.dataset.productId, variant_id: String(variantId)});
      button.textContent = 'Hinzugefügt ✓';
      setTimeout(() => window.location.reload(), 450);
    } catch (error) {
      button.textContent = 'Bitte erneut';
      button.disabled = false;
      button.dataset.busy = 'false';
      setTimeout(() => { button.textContent = initialText; }, 1800);
    }
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-enterprise-cart-rec-link]');
    if (!link) return;
    const card = link.closest('[data-enterprise-cart-rec-product]');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event: 'enterprise_cart_cross_sell_click', product_id: card ? card.dataset.enterpriseCartRecProduct : undefined});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enterprise-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalizeToken = (token) => {
    const aliases = {
      hosen: 'hose',
      arbeitshosen: 'arbeitshose',
      latzhosen: 'latzhose',
      bundhosen: 'bundhose',
      jacken: 'jacke',
      arbeitsjacken: 'arbeitsjacke',
      schuhe: 'schuh',
      arbeitsschuhe: 'arbeitsschuh',
      sicherheitsschuhe: 'sicherheitsschuh',
      handschuhe: 'handschuh',
      arbeitshandschuhe: 'arbeitshandschuh',
      westen: 'weste',
      groesse: '',
      größe: '',
      grösse: '',
      groesser: '',
      größer: '',
      size: '',
      artikelnummer: '',
      artikel: '',
      nummer: '',
      nr: ''
    };

    return Object.prototype.hasOwnProperty.call(aliases, token) ? aliases[token] : token;
  };

  const normalizeQuery = (value) => {
    const cleaned = value
      .toLowerCase()
      .replace(/[.,;:_+|/\\()[\]{}]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    const tokens = cleaned
      .split(' ')
      .map(normalizeToken)
      .filter(Boolean);

    return {
      tokens,
      normalized: tokens.join(' ')
    };
  };

  const escapeHtml = (value) => {
    return String(value ?? '').replace(/[&<>"']/g, (character) => {
      const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      };
      return map[character];
    });
  };

  const formatMoney = (value) => {
    if (value === null || value === undefined || value === '') return '';

    const text = String(value).trim();
    const number = Number(text.replace(',', '.'));

    if (!Number.isFinite(number)) return text;

    const amount = text.includes('.') || text.includes(',')
      ? number
      : number / 100;

    return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  };

  const getImage = (product) => {
    if (typeof product.image === 'string') return product.image;
    if (product.image && product.image.url) return product.image.url;
    if (product.featured_image && product.featured_image.url) return product.featured_image.url;
    if (typeof product.featured_image === 'string') return product.featured_image;
    return '';
  };

  const productKey = (product) => {
    return product.id || product.handle || product.url || product.title;
  };

  const scoreProduct = (product, tokens) => {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const title = String(product.title || '').toLowerCase();
    const vendor = String(product.vendor || '').toLowerCase();
    const haystack = [
      product.title,
      product.vendor,
      product.type,
      product.product_type,
      ...(Array.isArray(product.tags) ? product.tags : []),
      ...variants.flatMap((variant) => [variant.title, variant.sku])
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    return tokens.reduce((score, token) => {
      if (title.includes(token)) score += 6;
      if (vendor.includes(token)) score += 5;
      if (haystack.includes(token)) score += 2;
      return score;
    }, 0);
  };

  const initSearch = (root) => {
    if (root.dataset.searchReady === 'true') return;
    root.dataset.searchReady = 'true';

    const form = root.querySelector('form.enterprise-search');
    const input = root.querySelector('[data-enterprise-live-search-input]');
    const results = root.querySelector('[data-enterprise-live-search-results]');

    if (!form || !input || !results) return;

    const rootUrl = form.dataset.rootUrl || '/';
    const searchUrl = form.action;
    const cache = new Map();

    let timer = null;
    let controller = null;

    const close = () => {
      results.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
    };

    const open = () => {
      results.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    };

    const fetchProducts = async (query, signal) => {
      const cacheKey = query.toLowerCase();

      if (cache.has(cacheKey)) {
        return cache.get(cacheKey);
      }

      const params = new URLSearchParams();
      params.set('q', query);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '10');
      params.set('resources[options][unavailable_products]', 'last');
      params.set(
        'resources[options][fields]',
        'title,product_type,vendor,variants.sku,variants.title,variants.barcode,tag'
      );
      params.set('resources[options][prefix]', 'last');

      const response = await fetch(rootUrl + 'search/suggest.json?' + params.toString(), {
        headers: {
          Accept: 'application/json'
        },
        signal
      });

      if (!response.ok) {
        throw new Error('HTTP ' + response.status);
      }

      const payload = await response.json();

      const products =
        payload &&
        payload.resources &&
        payload.resources.results &&
        Array.isArray(payload.resources.results.products)
          ? payload.resources.results.products
          : [];

      cache.set(cacheKey, products);
      return products;
    };

    const render = (products, query, tokens) => {
      if (!products.length) {
        results.innerHTML =
          '<div class="enterprise-search-results__status">Keine passenden Produkte gefunden.</div>';
        open();
        return;
      }

      const ranked = products
        .map((product) => ({
          product,
          score: scoreProduct(product, tokens)
        }))
        .sort((a, b) => b.score - a.score)
        .slice(0, 8)
        .map((entry) => entry.product);

      const rows = ranked.map((product) => {
        const variants = Array.isArray(product.variants) ? product.variants : [];
        const queryLower = query.toLowerCase();

        const variant =
          variants.find((item) =>
            (String(item.title || '') + ' ' + String(item.sku || '') + ' ' + String(item.barcode || ''))
              .toLowerCase()
              .includes(queryLower)
          ) ||
          variants.find((item) => {
            const variantText =
              (String(item.title || '') + ' ' + String(item.sku || '') + ' ' + String(item.barcode || ''))
                .toLowerCase();
            return tokens.some((token) => variantText.includes(token));
          }) ||
          variants[0] ||
          null;

        const sku = variant && variant.sku ? variant.sku : '';
        const variantTitle =
          variant && variant.title && variant.title !== 'Default Title'
            ? variant.title
            : '';

        const meta = [product.vendor || '', variantTitle, sku ? 'SKU: ' + sku : '']
          .filter(Boolean)
          .join(' · ');

        const image = getImage(product);
        const price =
          product.price !== undefined
            ? product.price
            : variant
              ? variant.price
              : '';

        return (
          '<a class="enterprise-search-result" role="option" href="' +
          escapeHtml(product.url || '#') +
          '">' +
            (image
              ? '<img class="enterprise-search-result__image" src="' + escapeHtml(image) + '" alt="" loading="lazy">'
              : '<span class="enterprise-search-result__image"></span>') +
            '<span class="enterprise-search-result__copy">' +
              '<strong class="enterprise-search-result__title">' +
                escapeHtml(product.title || '') +
              '</strong>' +
              '<small class="enterprise-search-result__meta">' +
                escapeHtml(meta) +
              '</small>' +
            '</span>' +
            '<span class="enterprise-search-result__price">' +
              escapeHtml(formatMoney(price)) +
            '</span>' +
          '</a>'
        );
      }).join('');

      const moreUrl = searchUrl + '?q=' + encodeURIComponent(query);

      results.innerHTML =
        rows +
        '<a class="enterprise-search-results__footer" href="' +
        escapeHtml(moreUrl) +
        '">Alle Ergebnisse anzeigen</a>';

      open();
    };

    const run = async () => {
      const query = input.value.trim();

      if (query.length < 2) {
        close();
        return;
      }

      if (controller) {
        controller.abort();
      }

      controller = new AbortController();

      const normalized = normalizeQuery(query);
      const candidates = [query];

      if (normalized.normalized && normalized.normalized !== query.toLowerCase()) {
        candidates.push(normalized.normalized);
      }

      normalized.tokens.forEach((token) => {
        if (token.length >= 2) candidates.push(token);
      });

      const uniqueCandidates = [...new Set(candidates)].slice(0, 6);

      try {
        const batches = await Promise.all(
          uniqueCandidates.map((candidate) =>
            fetchProducts(candidate, controller.signal).catch(() => [])
          )
        );

        const merged = [];
        const seen = new Set();

        batches.flat().forEach((product) => {
          const key = productKey(product);
          if (!key || seen.has(key)) return;
          seen.add(key);
          merged.push(product);
        });

        render(merged, query, normalized.tokens);
      } catch (error) {
        if (error.name !== 'AbortError') {
          results.innerHTML =
            '<div class="enterprise-search-results__status">Suche konnte nicht geladen werden.</div>';
          open();
        }
      }
    };

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(run, 160);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2) run();
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) close();
    });
  };

  const boot = (scope = document) => {
    scope.querySelectorAll('[data-enterprise-live-search]').forEach(initSearch);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });
})();

(() => {
  let refreshVersion = 0;
  document.addEventListener('cart:refresh', async () => {
    const version = ++refreshVersion;
    try {
      const base = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      const response = await fetch(base + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (version !== refreshVersion || !Number.isInteger(cart.item_count)) return;
      document.querySelectorAll('.enterprise-cart-link span').forEach((count) => {
        count.textContent = String(cart.item_count);
      });
    } catch (error) {
      console.warn('Cart count refresh failed', error);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enterprise-product-v3"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-epv3-section]').forEach((root) => {
    if (root.dataset.epv3Ready === 'true') return;
    root.dataset.epv3Ready = 'true';
    const sizeDialog = root.querySelector('[data-epv3-size-dialog]');
    root.querySelectorAll('[data-epv3-size-open]').forEach((link) => link.addEventListener('click', (event) => {
      if (!sizeDialog || typeof sizeDialog.showModal !== 'function') return;
      event.preventDefault();
      sizeDialog.showModal();
    }));
    if (sizeDialog) {
      sizeDialog.querySelector('[data-epv3-size-close]').addEventListener('click', () => sizeDialog.close());
      sizeDialog.addEventListener('click', (event) => {
        const bounds = sizeDialog.getBoundingClientRect();
        if (event.target === sizeDialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) sizeDialog.close();
      });
    }
    const variantsEl = root.querySelector('[data-epv3-variants]');
    if (!variantsEl) return;

    let variants = JSON.parse(variantsEl.textContent || '[]');
    let ajaxVariants = [];
    const productUrl = root.dataset.productUrl || '';

    const loadAjaxVariants = async () => {
      if (!productUrl) return;
      try {
        const response = await fetch(productUrl + '.js', {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;
        const productData = await response.json();
        if (productData && Array.isArray(productData.variants)) {
          ajaxVariants = productData.variants;
        }
      } catch (error) {
        ajaxVariants = [];
      }
    };

    const groups = Array.from(root.querySelectorAll('[data-epv3-option-group]'));
    const selected = groups.map((group) => {
      const chosen = group.querySelector('.is-selected[data-epv3-option]');
      return chosen ? chosen.dataset.value : '';
    });

    const variantInput = root.querySelector('[data-epv3-variant-id]');
    const price = root.querySelector('[data-epv3-price]');
    const comparePrice = root.querySelector('[data-epv3-compare]');
    const stickyPrice = root.querySelector('[data-epv3-sticky-price]');
    const sku = root.querySelector('[data-epv3-sku]');
    const stock = root.querySelector('[data-epv3-stock]');
    const stockDot = root.querySelector('[data-epv3-stock-dot]');
    const add = root.querySelector('[data-epv3-add]');
    const addLabel = root.querySelector('[data-epv3-add-label]');
    const stickyAdd = root.querySelector('[data-epv3-sticky-add]');
    const stickyOption = root.querySelector('[data-epv3-sticky-option]');
    const mainImage = root.querySelector('.epv3__main-media img');
    const stickyImage = root.querySelector('[data-epv3-sticky-image]');
    const currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'EUR';

    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency', currency:currency}).format((Number(cents) || 0) / 100);

    const applyVariant = () => {
      const allVariants = ajaxVariants.length ? ajaxVariants : variants;
      let variant = allVariants.find((item) => item.options.every((value, index) => value === selected[index]));

      if (!variant) {
        variant = allVariants.find((item) => {
          return selected.every((value, index) => {
            if (!value) return true;
            return item.options[index] === value;
          });
        });
      }

      const colorGroupIndex = groups.findIndex((group) => {
        const legend = group.querySelector('legend');
        const label = legend ? legend.textContent.toLowerCase() : '';
        return label.includes('farbe') || label.includes('color') || label.includes('colour');
      });

      let imageVariant = variant;

      if (colorGroupIndex >= 0 && selected[colorGroupIndex]) {
        const colorValue = selected[colorGroupIndex];

        imageVariant =
          allVariants.find((item) => {
            const itemImage =
              item.featured_image ||
              item.featured_media ||
              item.image;

            return item.options &&
              item.options[colorGroupIndex] === colorValue &&
              itemImage;
          }) ||
          variant;
      }

      if (!variant) {
        variant = imageVariant;
      }

      if (!variant) return;

      variantInput.value = variant.id;
      const formatted = money(variant.price);
      if (price) price.textContent = formatted;
      if (comparePrice) {
        if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
          comparePrice.textContent = money(variant.compare_at_price);
          comparePrice.classList.remove('is-hidden');
        } else {
          comparePrice.textContent = '';
          comparePrice.classList.add('is-hidden');
        }
      }
      if (stickyPrice) stickyPrice.textContent = formatted;
      if (sku) sku.textContent = variant.sku || '—';
      if (stock) stock.textContent = variant.available ? 'Auf Lager' : 'Nicht verfügbar';
      if (stockDot) stockDot.classList.toggle('is-off', !variant.available);
      if (add) add.disabled = !variant.available;
      if (stickyAdd) stickyAdd.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'In den Warenkorb' : 'Nicht verfügbar';
      if (stickyOption) stickyOption.textContent = variant.title || '';
      const ajaxVariant = ajaxVariants.find((item) => String(item.id) === String((imageVariant || variant).id));
      const liquidSource = imageVariant || variant;
      const liquidImage =
        liquidSource && liquidSource.featured_image && liquidSource.featured_image.src
          ? liquidSource.featured_image.src
          : (
              liquidSource && liquidSource.featured_media && liquidSource.featured_media.preview_image
                ? (liquidSource.featured_media.preview_image.src || liquidSource.featured_media.preview_image.url || '')
                : ''
            );
      const ajaxImage = ajaxVariant && ajaxVariant.featured_image
        ? (typeof ajaxVariant.featured_image === 'string'
          ? ajaxVariant.featured_image
          : (ajaxVariant.featured_image.src || ajaxVariant.featured_image.url || ''))
        : '';
      const variantImageUrl = ajaxImage || liquidImage;

      if (variantImageUrl && mainImage) {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = variantImageUrl;

        if (stickyImage) {
          stickyImage.removeAttribute('srcset');
          stickyImage.removeAttribute('sizes');
          stickyImage.src = variantImageUrl;
        }

        const cleanVariantSrc = variantImageUrl.split('?')[0];
        const matchingThumb = Array.from(root.querySelectorAll('[data-epv3-thumb]')).find((button) => {
          const thumbSrc = button.dataset.src || '';
          const cleanThumbSrc = thumbSrc.split('?')[0];
          const thumbFile = cleanThumbSrc.split('/').pop();
          const variantFile = cleanVariantSrc.split('/').pop();
          return cleanThumbSrc === cleanVariantSrc ||
            cleanThumbSrc.includes(cleanVariantSrc) ||
            cleanVariantSrc.includes(cleanThumbSrc) ||
            (thumbFile && variantFile && thumbFile === variantFile);
        });

        root.querySelectorAll('[data-epv3-thumb]').forEach((button) => {
          button.classList.toggle('is-active', button === matchingThumb);
        });
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    loadAjaxVariants().then(() => applyVariant());

    root.addEventListener('click', (event) => {
      const option = event.target.closest('[data-epv3-option]');
      if (option) {
        const index = Number(option.dataset.epv3Option);
        selected[index] = option.dataset.value;
        root.querySelectorAll('[data-epv3-option="' + index + '"]').forEach((button) => {
          const active = button === option;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        applyVariant();
        return;
      }
      const thumb = event.target.closest('[data-epv3-thumb]');
      if (thumb && mainImage) {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = thumb.dataset.src;
        root.querySelectorAll('[data-epv3-thumb]').forEach((button) => button.classList.toggle('is-active', button === thumb));
        return;
      }
      if (event.target.closest('[data-epv3-qty-minus]') || event.target.closest('[data-epv3-qty-plus]')) {
        const input = root.querySelector('[data-epv3-qty]');
        const change = event.target.closest('[data-epv3-qty-plus]') ? 1 : -1;
        input.value = Math.max(1, Number(input.value || 1) + change);
        return;
      }
      if (event.target.closest('[data-epv3-sticky-add]')) {
        const mainButton = root.querySelector('[data-epv3-add]');
        if (mainButton && !mainButton.disabled) mainButton.click();
      }
    });

    const form = root.querySelector('[data-epv3-form]');
    if (form) form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const message = root.querySelector('[data-epv3-message]');
      if (message) message.textContent = 'Wird hinzugefügt …';
      if (add) add.disabled = true;
      try {
        const base = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
        const response = await fetch(base + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:new FormData(form)});
        if (!response.ok) throw new Error('add failed');
        const payload = await response.json();
        if (message) message.textContent = 'Zum Warenkorb hinzugefügt.';
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
        if (
          window.MinimogEvents &&
          window.MinimogTheme &&
          MinimogTheme.pubSubEvents &&
          MinimogTheme.pubSubEvents.cartUpdate
        ) {
          window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { source: 'enterprise-product' });
        }
      } catch (error) {
        if (message) message.textContent = 'Bitte erneut versuchen.';
      } finally {
        applyVariant();
      }
    });

    const sticky = root.querySelector('[data-epv3-sticky]');
    if (sticky && add) {
      const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), {threshold:0.15});
      observer.observe(add);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enterprise-recovery-context"] && !Shopify.designMode) return;
  try {
    
(() => {
  const context = document.querySelector('[data-enterprise-recovery-context]');
  if (!context) return;

  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const segment = context.dataset.segment || 'STANDARD';
  const cartItems = Number(context.dataset.cartItems || 0);
  const cartValueCents = Number(context.dataset.cartValueCents || 0);
  const b2bThreshold = Number(context.dataset.b2bThreshold || 10);
  const email1 = Number(context.dataset.email1Hours || 2);
  const email2 = Number(context.dataset.email2Hours || 24);
  const email3 = Number(context.dataset.email3Hours || 72);
  const version = context.dataset.version || 'enterprise-recovery-v1';

  const attributes = {
    'Enterprise Recovery Segment': segment,
    'Enterprise Recovery Version': version,
    'Enterprise Recovery E1': `${email1}h`,
    'Enterprise Recovery E2': `${email2}h`,
    'Enterprise Recovery E3': `${email3}h`,
    'Enterprise Recovery B2B Threshold': String(b2bThreshold)
  };

  const injectIntoCartForms = () => {
    const forms = document.querySelectorAll('form[action*="/cart"]');
    forms.forEach((form) => {
      Object.entries(attributes).forEach(([key, value]) => {
        const fieldName = `attributes[${key}]`;
        let input = Array.from(form.querySelectorAll('input[type="hidden"]')).find((node) => node.name === fieldName);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = fieldName;
          form.appendChild(input);
        }
        input.value = value;
      });
    });
  };

  const persistAttributes = async () => {
    const response = await fetch(`${shopRoot}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes })
    });
    if (!response.ok) throw new Error('Enterprise recovery context could not be saved');
    return response.json();
  };

  injectIntoCartForms();

  const signature = JSON.stringify({ segment, cartItems, cartValueCents, email1, email2, email3, version });
  const signatureKey = 'enterpriseRecoveryContextSignature';
  let currentSignature = null;
  try { currentSignature = sessionStorage.getItem(signatureKey); } catch (error) {}

  if (currentSignature !== signature) {
    persistAttributes()
      .then(() => {
        try { sessionStorage.setItem(signatureKey, signature); } catch (error) {}
      })
      .catch(() => {});
  }

  window.dataLayer = window.dataLayer || [];
  const trackingKey = `enterpriseRecoveryTracked:${signature}`;
  let tracked = false;
  try { tracked = sessionStorage.getItem(trackingKey) === '1'; } catch (error) {}
  if (!tracked) {
    window.dataLayer.push({
      event: 'enterprise_recovery_eligible',
      recovery_segment: segment.toLowerCase(),
      cart_items: cartItems,
      cart_value: cartValueCents / 100,
      recovery_email_1_hours: email1,
      recovery_email_2_hours: email2,
      recovery_email_3_hours: email3
    });
    try { sessionStorage.setItem(trackingKey, '1'); } catch (error) {}
  }

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if (!checkout) return;

    injectIntoCartForms();
    persistAttributes().catch(() => {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'enterprise_checkout_started',
      recovery_segment: segment.toLowerCase(),
      cart_items: cartItems,
      cart_value: cartValueCents / 100
    });
  }, { capture: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enterprise-smart-cross-sell"]) return;
  try {
    
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-enterprise-quick-add]');
  if (!button || button.dataset.busy === 'true') return;
  const variantId = Number(button.dataset.variantId);
  if (!variantId) return;
  const originalText = button.textContent;
  button.dataset.busy = 'true';
  button.disabled = true;
  button.textContent = 'Wird hinzugefügt …';
  try {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const response = await fetch(`${root}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1}]})});
    if (!response.ok) throw new Error('Cart add failed');
    button.textContent = 'Hinzugefügt ✓';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event:'enterprise_cross_sell_add',product_id:button.dataset.productId,variant_id:String(variantId)});
    document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{source:'enterprise-cross-sell'}}));
    setTimeout(()=>{button.textContent=originalText;button.disabled=false;button.dataset.busy='false';},1800);
  } catch (error) {
    button.textContent = 'Bitte erneut';
    button.disabled = false;
    button.dataset.busy = 'false';
    setTimeout(()=>{button.textContent=originalText;},1800);
  }
});
document.addEventListener('click',(event)=>{const link=event.target.closest('[data-enterprise-rec-link]');if(!link)return;const card=link.closest('[data-enterprise-rec-product]');window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'enterprise_cross_sell_click',product_id:card?card.dataset.enterpriseRecProduct:undefined});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-product-compare"]) return;
  try {
    
(() => {
  const STORAGE_KEY = 'm-compare-products';
  const root = document.querySelector('[data-enterprise-compare-page]');
  if (!root || root.dataset.compareReady === 'true') return;
  root.dataset.compareReady = 'true';

  const content = root.querySelector('[data-enterprise-compare-content]');
  const empty = root.querySelector('[data-enterprise-compare-empty]');
  const labels = root.dataset;
  const rootUrl = labels.rootUrl || '/';
  let onlyDifferences = false;

  document.querySelectorAll('[data-enterprise-compare-dock]').forEach((dock) => {
    dock.classList.remove('is-visible');
    dock.style.display = 'none';
  });

  const escapeHtml = (value) =>
    String(value ?? '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    }[char]));

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter(Boolean))].slice(0, 4) : [];
    } catch (error) {
      return [];
    }
  };

  const write = (items) => {
    const next = [...new Set(items.filter(Boolean))].slice(0, 4);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    return next;
  };

  const money = (cents) => {
    const currency =
      window.Shopify && Shopify.currency && Shopify.currency.active
        ? Shopify.currency.active
        : 'EUR';

    return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      style: 'currency',
      currency
    }).format((Number(cents) || 0) / 100);
  };

  const textFromHtml = (html) => {
    if (!html) return '';
    const node = document.createElement('div');
    node.innerHTML = html;
    return (node.textContent || node.innerText || '').replace(/\s+/g, ' ').trim();
  };

  const normalizeOptions = (product) => {
    const raw = Array.isArray(product.options) ? product.options : [];
    return raw.map((option, index) => {
      if (option && typeof option === 'object') {
        return {
          name: String(option.name || labels.selectOption),
          values: Array.isArray(option.values) ? option.values : []
        };
      }

      return {
        name: String(option || labels.selectOption),
        values: [...new Set(
          (Array.isArray(product.variants) ? product.variants : [])
            .map((variant) => variant.options && variant.options[index])
            .filter(Boolean)
        )]
      };
    });
  };

  const getImage = (product, variant) => {
    if (variant && variant.featured_image) {
      if (typeof variant.featured_image === 'string') return variant.featured_image;
      if (variant.featured_image.src) return variant.featured_image.src;
    }

    if (typeof product.featured_image === 'string' && product.featured_image) return product.featured_image;
    if (product.featured_image && product.featured_image.src) return product.featured_image.src;

    if (Array.isArray(product.images) && product.images.length) {
      const image = product.images[0];
      return typeof image === 'string' ? image : (image && image.src ? image.src : '');
    }

    return '';
  };

  const getColorImageVariant = (product, selected, optionDefs, fallback) => {
    const colorIndex = optionDefs.findIndex((option) => {
      const name = option.name.toLowerCase();
      return name.includes('farbe') || name.includes('color') || name.includes('colour');
    });

    if (colorIndex < 0 || !selected[colorIndex]) return fallback;

    return (product.variants || []).find((variant) => {
      return variant.options &&
        variant.options[colorIndex] === selected[colorIndex] &&
        variant.featured_image;
    }) || fallback;
  };

  const getOptionValues = (product, optionDefs, names) => {
    const wanted = names.map((name) => name.toLowerCase());
    const index = optionDefs.findIndex((option) =>
      wanted.some((needle) => option.name.toLowerCase().includes(needle))
    );

    return index >= 0 ? optionDefs[index].values : [];
  };

  const productUrl = (handle) =>
    rootUrl.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle);

  const productJsonUrl = (handle) => productUrl(handle) + '.js';

  const optionSelectsHtml = (product, optionDefs, selected) => {
    return optionDefs.map((option, index) => {
      if (!option.values.length) return '';
      const options = option.values.map((value) =>
        '<option value="' + escapeHtml(value) + '"' +
        (selected[index] === value ? ' selected' : '') +
        '>' + escapeHtml(value) + '</option>'
      ).join('');

      return '<label class="enterprise-compare-card__field">' +
        '<span>' + escapeHtml(option.name) + '</span>' +
        '<select data-variant-option="' + index + '">' + options + '</select>' +
      '</label>';
    }).join('');
  };

  const cardHtml = (product, handle) => {
    const optionDefs = normalizeOptions(product);
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const initialVariant = variants.find((variant) => variant.available) || variants[0] || null;
    const selected = initialVariant && Array.isArray(initialVariant.options)
      ? initialVariant.options.slice()
      : optionDefs.map((option) => option.values[0] || '');
    const imageVariant = getColorImageVariant(product, selected, optionDefs, initialVariant);
    const image = getImage(product, imageVariant);
    const colors = getOptionValues(product, optionDefs, ['farbe', 'color', 'colour']);
    const sizes = getOptionValues(product, optionDefs, ['größe', 'groesse', 'size']);
    const description = textFromHtml(product.description || '');
    const available = !!(initialVariant ? initialVariant.available : product.available);
    const price = initialVariant ? initialVariant.price : (product.price_min || product.price || 0);
    const compareAt = initialVariant ? initialVariant.compare_at_price : (product.compare_at_price_max || product.compare_at_price || 0);
    const onSale = Number(compareAt) > Number(price);
    const href = productUrl(handle);
    const type = product.type || '—';
    const sku = initialVariant && initialVariant.sku ? initialVariant.sku : '—';

    return '<article class="enterprise-compare-card" data-handle="' + escapeHtml(handle) + '">' +
      '<button type="button" class="enterprise-compare-card__remove" data-remove="' + escapeHtml(handle) + '" aria-label="' + escapeHtml(labels.remove) + '">×</button>' +
      '<div class="enterprise-compare-card__head">' +
        '<a class="enterprise-compare-card__image-link" href="' + escapeHtml(href) + '">' +
          (image ? '<img class="enterprise-compare-card__image" data-card-image src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title || '') + '">' : '') +
        '</a>' +
        '<div class="enterprise-compare-card__vendor">' + escapeHtml(product.vendor || '') + '</div>' +
        '<h2 class="enterprise-compare-card__title"><a href="' + escapeHtml(href) + '">' + escapeHtml(product.title || '') + '</a></h2>' +
        '<div class="enterprise-compare-card__price"><strong data-card-price>' + escapeHtml(money(price)) + '</strong>' +
          '<s data-card-compare' + (onSale ? '' : ' hidden') + '>' + (onSale ? escapeHtml(money(compareAt)) : '') + '</s>' +
        '</div>' +
        '<div class="enterprise-compare-card__stock' + (available ? '' : ' is-off') + '" data-card-stock-wrap>' +
          '<span class="enterprise-compare-card__stock-dot"></span><span data-card-stock>' + escapeHtml(available ? labels.inStock : labels.unavailable) + '</span>' +
        '</div>' +
      '</div>' +
      '<div class="enterprise-compare-card__body">' +
        '<div class="enterprise-compare-card__description" data-description-box>' +
          '<strong>' + escapeHtml(labels.description) + '</strong>' +
          '<p>' + escapeHtml(description || '—') + '</p>' +
          (description.length > 260 ? '<button type="button" data-description-toggle>' + escapeHtml(labels.more) + '</button>' : '') +
        '</div>' +
        '<dl class="enterprise-compare-card__specs">' +
          '<div data-diff-key="brand" data-diff-value="' + escapeHtml(product.vendor || '') + '"><dt>' + escapeHtml(labels.brand) + '</dt><dd>' + escapeHtml(product.vendor || '—') + '</dd></div>' +
          '<div data-diff-key="type" data-diff-value="' + escapeHtml(type) + '"><dt>' + escapeHtml(labels.type) + '</dt><dd>' + escapeHtml(type) + '</dd></div>' +
          '<div data-diff-key="colors" data-diff-value="' + escapeHtml(colors.join('|')) + '"><dt>' + escapeHtml(labels.colors) + '</dt><dd>' + escapeHtml(colors.length ? colors.join(', ') : '—') + '</dd></div>' +
          '<div data-diff-key="sizes" data-diff-value="' + escapeHtml(sizes.join('|')) + '"><dt>' + escapeHtml(labels.sizes) + '</dt><dd>' + escapeHtml(sizes.length ? sizes.join(', ') : '—') + '</dd></div>' +
          '<div data-diff-key="availability" data-diff-value="' + (available ? '1' : '0') + '"><dt>' + escapeHtml(labels.availability) + '</dt><dd class="' + (available ? 'is-available' : 'is-unavailable') + '" data-card-availability>' + escapeHtml(available ? labels.inStock : labels.unavailable) + '</dd></div>' +
        '</dl>' +
        '<div class="enterprise-compare-card__variant">' +
          '<div class="enterprise-compare-card__variant-title">' + escapeHtml(labels.chooseVariant) + '</div>' +
          optionSelectsHtml(product, optionDefs, selected) +
          '<div class="enterprise-compare-card__sku">' + escapeHtml(labels.sku) + ': <strong data-card-sku>' + escapeHtml(sku) + '</strong></div>' +
        '</div>' +
        '<div class="enterprise-compare-card__buy">' +
          '<button type="button" class="enterprise-compare-card__add" data-add-cart' + (available && initialVariant ? '' : ' disabled') + '>' + escapeHtml(labels.addCart) + '</button>' +
          '<a class="enterprise-compare-card__view" href="' + escapeHtml(href) + '">' + escapeHtml(labels.view) + '</a>' +
          '<div class="enterprise-compare-card__message" data-card-message aria-live="polite"></div>' +
        '</div>' +
      '</div>' +
      '<script type="application/json" data-card-product>' + JSON.stringify(product).replace(/</g, '\\u003c') + '</script>' +
    '</article>';
  };

  const classifyDifferences = () => {
    const rows = Array.from(content.querySelectorAll('[data-diff-key]'));
    const keys = [...new Set(rows.map((row) => row.dataset.diffKey))];

    keys.forEach((key) => {
      const group = rows.filter((row) => row.dataset.diffKey === key);
      const values = [...new Set(group.map((row) => row.dataset.diffValue || ''))];
      const different = values.length > 1;

      group.forEach((row) => {
        row.classList.toggle('is-different', different);
        row.classList.toggle('is-equal', !different);
        row.classList.toggle('is-hidden-difference', onlyDifferences && !different);
      });
    });
  };

  const render = async () => {
    const handles = read();

    if (!handles.length) {
      content.innerHTML = '';
      content.classList.add('m:hidden');
      empty.classList.remove('m:hidden');
      return;
    }

    content.classList.remove('m:hidden');
    empty.classList.add('m:hidden');
    content.innerHTML = '<div class="enterprise-compare-page__loading">' + escapeHtml(labels.loading) + '</div>';

    const results = await Promise.all(handles.map(async (handle) => {
      try {
        const response = await fetch(productJsonUrl(handle), {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });

        if (!response.ok) return null;
        return { handle, product: await response.json() };
      } catch (error) {
        return null;
      }
    }));

    const loaded = results.filter(Boolean);

    if (!loaded.length) {
      content.innerHTML =
        '<div class="enterprise-compare-page__error"><strong>' + escapeHtml(labels.error) + '</strong>' +
        '<button type="button" data-retry>' + escapeHtml(labels.retry) + '</button></div>';
      return;
    }

    content.innerHTML = loaded.map((entry) => cardHtml(entry.product, entry.handle)).join('');
    classifyDifferences();
  };

  const updateVariant = (card, clearMessage = true) => {
    const productNode = card.querySelector('[data-card-product]');
    if (!productNode) return;

    let product;
    try {
      product = JSON.parse(productNode.textContent || '{}');
    } catch (error) {
      return;
    }

    const selects = Array.from(card.querySelectorAll('[data-variant-option]'));
    const selected = selects.map((select) => select.value);
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const optionDefs = normalizeOptions(product);

    const variant = variants.find((item) =>
      Array.isArray(item.options) &&
      item.options.every((value, index) => value === selected[index])
    );

    const addButton = card.querySelector('[data-add-cart]');
    const price = card.querySelector('[data-card-price]');
    const compare = card.querySelector('[data-card-compare]');
    const stock = card.querySelector('[data-card-stock]');
    const stockWrap = card.querySelector('[data-card-stock-wrap]');
    const availability = card.querySelector('[data-card-availability]');
    const sku = card.querySelector('[data-card-sku]');
    const image = card.querySelector('[data-card-image]');
    const message = card.querySelector('[data-card-message]');

    if (message && clearMessage) {
      message.textContent = '';
      message.classList.remove('is-error');
    }

    if (!variant) {
      if (addButton) addButton.disabled = true;
      if (stock) stock.textContent = labels.unavailable;
      if (availability) availability.textContent = labels.unavailable;
      if (stockWrap) stockWrap.classList.add('is-off');
      return;
    }

    const imageVariant = getColorImageVariant(product, selected, optionDefs, variant);
    const imageUrl = getImage(product, imageVariant);

    if (price) price.textContent = money(variant.price);
    if (compare) {
      if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
        compare.hidden = false;
        compare.textContent = money(variant.compare_at_price);
      } else {
        compare.hidden = true;
        compare.textContent = '';
      }
    }

    if (stock) stock.textContent = variant.available ? labels.inStock : labels.unavailable;
    if (availability) {
      availability.textContent = variant.available ? labels.inStock : labels.unavailable;
      availability.classList.toggle('is-available', !!variant.available);
      availability.classList.toggle('is-unavailable', !variant.available);
      const row = availability.closest('[data-diff-key]');
      if (row) row.dataset.diffValue = variant.available ? '1' : '0';
    }
    if (stockWrap) stockWrap.classList.toggle('is-off', !variant.available);
    if (sku) sku.textContent = variant.sku || '—';
    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.dataset.variantId = variant.id;
    }
    if (image && imageUrl) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = imageUrl;
    }

    classifyDifferences();
  };

  root.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-option]');
    if (!select) return;
    const card = select.closest('.enterprise-compare-card');
    if (card) updateVariant(card);
  });

  root.addEventListener('click', async (event) => {
    const remove = event.target.closest('button[data-remove]');
    if (remove) {
      write(read().filter((item) => item !== (remove.dataset.remove || '')));
      render();
      return;
    }

    const retry = event.target.closest('button[data-retry]');
    if (retry) {
      render();
      return;
    }

    const toggleDescription = event.target.closest('button[data-description-toggle]');
    if (toggleDescription) {
      const box = toggleDescription.closest('[data-description-box]');
      if (!box) return;
      const expanded = box.classList.toggle('is-expanded');
      toggleDescription.textContent = expanded ? labels.less : labels.more;
      return;
    }

    const differenceToggle = event.target.closest('button[data-only-differences]');
    if (differenceToggle) {
      onlyDifferences = !onlyDifferences;
      differenceToggle.classList.toggle('is-active', onlyDifferences);
      differenceToggle.setAttribute('aria-pressed', onlyDifferences ? 'true' : 'false');
      differenceToggle.textContent = onlyDifferences ? labels.showAll : labels.onlyDifferences;
      classifyDifferences();
      return;
    }

    const clear = event.target.closest('button[data-clear-comparison]');
    if (clear) {
      write([]);
      render();
      return;
    }

    const add = event.target.closest('button[data-add-cart]');
    if (add) {
      const card = add.closest('.enterprise-compare-card');
      if (!card) return;

      updateVariant(card);
      const variantId = add.dataset.variantId;
      const message = card.querySelector('[data-card-message]');

      if (!variantId) {
        if (message) {
          message.textContent = labels.selectOption;
          message.classList.add('is-error');
        }
        return;
      }

      add.disabled = true;

      try {
        const response = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }]
          })
        });

        if (!response.ok) throw new Error('cart');

        if (message) {
          message.textContent = labels.added;
          message.classList.remove('is-error');
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        if (
          window.MinimogEvents &&
          window.MinimogTheme &&
          MinimogTheme.pubSubEvents &&
          MinimogTheme.pubSubEvents.cartUpdate
        ) {
          window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { source: 'enterprise-ui' });
        }
      } catch (error) {
        if (message) {
          message.textContent = labels.addError;
          message.classList.add('is-error');
        }
      } finally {
        updateVariant(card, false);
      }
    }
  });

  const boot = async () => {
    await render();
    content.querySelectorAll('.enterprise-compare-card').forEach((card) => updateVariant(card));
  };

  boot();
})();

  } catch(e) { console.error(e); }
})();
})();
